import { render, staticRenderFns } from "./OrgaoEdit.vue?vue&type=template&id=2b6215dd&scoped=true&"
import script from "./OrgaoEdit.vue?vue&type=script&lang=js&"
export * from "./OrgaoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6215dd",
  null
  
)

export default component.exports